import { z } from "zod";
import { GRADE, MODULE, SUB_MODULE } from "../consts";

export const schema = z.object({
  [GRADE]: z.string().optional(),
  [MODULE]: z.string().optional(),
  [SUB_MODULE]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
